import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { loadScript } from '../../utils';

const BUILD_URL = process.env.REACT_APP_EMBED_CHART_V5;

const ChartV5 = ({ uuid }) => {
  useEffect(() => {
    loadScript(BUILD_URL, 'main.js');
  }, []);

  return (
    uuid && (
      <Container>
        <div
          style={{
            width: '100vw',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <section
            style={{ width: '100%', flex: 1 }}
            id="irobot-embedded-chart-v5"
            data-experience-id={uuid}
            data-api-url={`${process.env.REACT_APP_API_BASE_URL}/v4`}
            data-build-url={BUILD_URL}
          />
        </div>
      </Container>
    )
  );
};

const Container = styled.div`
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
`;

ChartV5.propTypes = {
  uuid: PropTypes.string.isRequired,
};

export default ChartV5;
